import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { ImageBubble } from '@/stores/interfaces'

export const useImageStore = defineStore('imageStore', () => {
  const images = ref<ImageBubble[]>([])
  const searchQuery = ref('')

  const setSearchQuery = (query: string) => {
    searchQuery.value = query
  }

  const filteredImages = computed(() => {
    if (!searchQuery.value) return images.value
    const lowercaseQuery = searchQuery.value.toLowerCase()
    return images.value.filter(
      (image) =>
        image.filename.toLowerCase().includes(lowercaseQuery) ||
        image.description?.toLowerCase().includes(lowercaseQuery)
    )
  })

  function removeImage(uuid: string) {
    images.value = images.value.filter((image) => image.uuid !== uuid)
  }

  return {
    images,
    searchQuery,
    setSearchQuery,
    filteredImages,
    removeImage,
  }
})
